module.exports = __webpack_public_path__ + "img/photo-0016.351a854c.jpg";